(function () {
  'use strict';
  function onReady(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  // Self-heal the header search FORM (header.liquid injects it once via inline
  // script that does NOT re-run after a section morph). Mirror that markup here.
  function ensureSearch() {
    if (document.querySelector('.bes-header-search')) return;
    var topRow = document.querySelector('.header__row--top, .header__row:first-of-type');
    if (!topRow) return;
    var columns = topRow.querySelector('.header__columns');
    var rightCol = topRow.querySelector('.header__column--right');
    if (!columns) return;
    var form = document.createElement('form');
    form.action = '/search'; form.method = 'get'; form.setAttribute('role', 'search');
    form.className = 'bes-header-search';
    form.innerHTML = '<input type="search" name="q" placeholder="Search bearings, belts, model numbers…" aria-label="Search products" autocomplete="off" /><button type="submit">Search</button>';
    if (rightCol && rightCol.parentElement === columns) columns.insertBefore(form, rightCol);
    else columns.appendChild(form);
  }
  function ensureHeader() { ensureSearch(); ensureButton(); styleResultTitle(); }

  // Inject (or re-inject) the "Search Vehicle" button. Horizon hydrates the
  // header as a custom element and can wipe injected DOM, so we run this on
  // ready, after delays, and on every relevant header mutation.
  function ensureButton() {
    var form = document.querySelector('.bes-header-search');
    if (!form) return;
    if (document.querySelector('.bes-vehicle-btn')) return;
    var wrap = form.closest('.bes-header-search-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'bes-header-search-wrap';
      form.parentNode.insertBefore(wrap, form);
      wrap.appendChild(form);
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bes-vehicle-btn';
    btn.setAttribute('aria-label', 'Search by vehicle');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l1.4-4.2A2 2 0 0 1 8.3 7h7.4a2 2 0 0 1 1.9 1.8L19 13"/><rect x="4" y="13" width="16" height="4" rx="1"/><circle cx="7.5" cy="17.5" r="1.4"/><circle cx="16.5" cy="17.5" r="1.4"/></svg><span>Search Vehicle</span>';
    btn.addEventListener('click', openVehicleSearch);
    wrap.appendChild(btn);
  }

  // Force the result-page title styling inline. The app's result stylesheet
  // loads after ours with high specificity, so we win by setting inline
  // !important directly on the element.
  function styleResultTitle() {
    document.querySelectorAll('.ymm_pg_title').forEach(function (t) {
      t.style.setProperty('text-transform', 'none', 'important');
      t.style.setProperty('font-size', '32px', 'important');
      t.style.setProperty('font-weight', '700', 'important');
      t.style.setProperty('color', '#0F2547', 'important');
      t.style.setProperty('font-family', 'var(--font-heading--family, Inter, sans-serif)', 'important');
      t.style.setProperty('text-align', 'center', 'important');
    });
  }

  onReady(function () {
    ensureHeader();
    // Belt-and-suspenders against late header hydration / late result render.
    [300, 800, 1600, 3000].forEach(function (t) { setTimeout(function () { ensureHeader(); }, t); });
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; ensureHeader(); });
    });
    obs.observe(document.body, { childList: true, subtree: true });
    // Backstop: poll for ~40s to survive late/repeat header hydration. The
    // ensureButton guard makes each tick a no-op once the button is present.
    var ticks = 0;
    var iv = setInterval(function () { ensureHeader(); if (++ticks >= 40) clearInterval(iv); }, 1000);

    // Modal close wiring.
    var modal = document.querySelector('.bes-ymm-modal');
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal || (e.target.closest && e.target.closest('.bes-ymm-modal__close'))) closeModal();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }
  });

  function openVehicleSearch() {
    // Always open the modal — it's rendered on every page (the homepage app
    // block uses #ymm_searchbox, the modal uses #ymm_searchbox_cont, so there
    // is no ID collision even on the home page).
    var modal = document.querySelector('.bes-ymm-modal');
    if (modal) { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; return; }
    // Fallback if the modal somehow isn't present: scroll to an in-page widget.
    var inPage = document.querySelector('.shopify-section #ymm_searchbox, .shopify-section #ymm_searchbox_cont');
    if (inPage) (inPage.closest('.shopify-section') || inPage).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function closeModal() {
    var modal = document.querySelector('.bes-ymm-modal');
    if (modal) { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
  window.besOpenVehicleSearch = openVehicleSearch;
})();
